import styled from "styled-components";

const FormContainer = styled.div`
	height: 100%;
	padding: 15px;
	background-color: beige;
	max-width: 640px;
	min-height: 100vh;
`;

export default FormContainer;